@if (isPPL) {
  <div class="ppl-card">
    <img src="/assets/icons/fi-rr-bulb.svg" alt="tip icon" />
    <p>{{ text }}</p>
  </div>
}
